import {
  watchUserDataRequested,
} from './getUserDataSaga';
import watchSetUserDataRequested from './setUserDataSaga';

export default [
  watchUserDataRequested(),
  watchSetUserDataRequested(),
];
